import { isEmpty } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { Field, useFormContext } from 'app/components/core/Form';
import { Input } from 'app/components/core/Input';

export function NameField() {
    const { t } = useTranslation();
    const { getFieldValue, setFieldValue } = useFormContext();

    function handleBlur(value) {
        if (isEmpty(value)) {
            setFieldValue('name', getFieldValue('credentials.username'));
        }
    }

    return (
        <Field
            component={Input}
            name="name"
            label={t('common:name')}
            placeholder={t('jobs:dialogs.serviceAccount.namePlaceholder')}
            onBlur={handleBlur}
        />
    );
}
